/** Canonical (AWS-style) Secret Manager id of a Datadog organization's admin
 * keys. Other providers rewrite it with their `replacer`. */
export const datadogAiAdminKeysSecretId = (organizationId: string): string =>
  `p0/install/datadog/${organizationId}/admin-keys`;

/** Canonical prefix that every token secret of a Datadog organization starts
 * with. Other providers rewrite it with their `replacer`. */
export const datadogAiAccessTokenPrefix = (organizationId: string): string =>
  `p0/access-token/datadog/${organizationId}/`;

/** The connector's Cloud Run service name. Its Lambda function name adds
 * "-aws". */
export const datadogAiConnectorName = "p0-connector-datadog-ai";
